import Text from 'components/Text/Text';
import React, { useRef } from 'react';
import DropdownMenu from './components/DropdownMenu';
import { Dropdown } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { TAssignDevicesSortBy } from 'modules/CustomersAndRestaurants/Restaurants/EditRestaurant/components/Forms/components/DevicesForm/devicesFormState/devicesFormContext';
import style from './SortBy.module.scss';

interface ISortBy {
	setSortBy: (value: TAssignDevicesSortBy) => void;
	sortBy: TAssignDevicesSortBy;
}

const SortBy: React.FC<ISortBy> = ({ sortBy, setSortBy }) => {
	const parentNodeRef = useRef<null | HTMLSpanElement>(null);

	return (
		<>
			<span ref={parentNodeRef} style={{ position: 'relative' }} />
			<Dropdown
				className={style.container}
				overlay={<DropdownMenu sortBy={sortBy} setSortBy={setSortBy} />}
				trigger={['click']}
				getPopupContainer={() => parentNodeRef.current as HTMLSpanElement}
				placement="bottomRight">
				<a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
					<Text translationNameSpace="form" translationKey="sortByLabel" theme="neutralLight" />
					<DownOutlined className={style.iconDropdown} />
				</a>
			</Dropdown>
		</>
	);
};

export default React.memo(SortBy);
